import BookmarksController from './bookmarks';

export default class HomeController extends BookmarksController {
  get dynamicGreeting() {
    return `${this.timeOfDayBasedGreeting}`.replace(
      '$name',
      this.currentUser.name as string,
    );
  }

  get timeOfDayBasedGreeting() {
    const hour = new Date().getHours();

    if (hour >= 6 && hour < 12) {
      return 'Good morning, $name';
    } else if (hour >= 12 && hour < 17) {
      return 'Good afternoon, $name';
    } else if (hour >= 17 && hour < 22) {
      return 'Good evening, $name';
    } else {
      return 'Still working $name? You night owl! 🦉';
    }
  }

  get hasNoFeatureAccess() {
    if (!this.betaService.groupIsSet) return false;
    return !this.betaService.isSaasCustomer && !this.betaService.isXrayCustomer;
  }
}
